import React from 'react';
import { SalesTerminal } from '../components/sales-terminal';

import NavLayout from './../components/layouts/NavLayout';
import CartBreakdownMobile from '../components/resuable-ui/cart-breakdown-mobile/index';

function SaleTerminal() {
	return (
		<section className="relative h-full">
			<NavLayout {...{ showBar: true }}>
				<SalesTerminal />
				<CartBreakdownMobile />
			</NavLayout>
		</section>
	);
}

export default SaleTerminal;
